import type { ReactNode } from "react";

/** Shared chrome for the legal pages — reuses the docs sidebar/content layout. */
export function LegalLayout({
  title,
  updated,
  sections,
  children,
}: {
  title: string;
  updated: string;
  sections: readonly { id: string; label: string }[];
  children: ReactNode;
}) {
  return (
    <div className="docs2">
      <aside className="docs2__side">
        <span className="docs2__side-head">{title}</span>
        <nav aria-label="Sections">
          {sections.map((s) => (
            <a key={s.id} href={`#${s.id}`}>
              {s.label}
            </a>
          ))}
        </nav>
      </aside>

      <main className="docs2__main">
        <header className="docs2__head">
          <span className="saas-chip">Legal</span>
          <h1 className="docs2__title">{title}</h1>
          <p className="docs2__lede">Last updated {updated}.</p>
        </header>
        {children}
      </main>
    </div>
  );
}
